import { useMemo } from "react";
import styled from "styled-components";
import {defaultThemeColors, fonts, themeColor} from "ui/theme";
import { USDollar } from "utils";
import { PriceBreakdown } from "../priceBreakdown/PriceBreakdown";
import moment from "moment/moment";

export const ClassDateCard = ({
    date: { type, date, time, cost },
    priceBreakdown,
    isOnline
}) => {
    const tooltipId = useMemo(() => {
        const uniqueSuffix = Math.random().toString(36).substr(2, 6);
        return `tooltip-${date}-${uniqueSuffix}`;
    }, [date]);

    const fullDate = moment(date).format("MMMM D, YYYY");
    const mobileDate = moment(date).format("MMM D");
    const cleanTime = moment(time, "hh:mm A").format("h:mmA");
    return (
        <CardContainer>
            <InfoColumn>
                <InfoLabel>Type</InfoLabel>
                <InfoValue>{isOnline ? "Online" : type}</InfoValue>
            </InfoColumn>

            <InfoColumn>
                <InfoLabel>Date</InfoLabel>
                <DesktopOnly>{fullDate}</DesktopOnly>
                <MobileOnly>{mobileDate}</MobileOnly>
            </InfoColumn>

            <InfoColumn>
                <InfoLabel>Time</InfoLabel>
                <InfoValue style={{ textTransform: "lowercase" }}>{cleanTime}</InfoValue>
            </InfoColumn>

            <InfoColumn>
                <InfoLabel>Cost</InfoLabel>
                <InfoValue>
                    <div className="price">
                        {USDollar.format(cost)}
                        {priceBreakdown ? (
                            <PriceBreakdown
                                price={priceBreakdown}
                                position="left"
                                size={20}
                                id={tooltipId}
                            />
                        ) : null}
                    </div>
                </InfoValue>
            </InfoColumn>
        </CardContainer>
    );
};

const CardContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    @media (max-width: 768px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
`;

const InfoColumn = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    gap: 6px;
`;

const InfoLabel = styled.span`
    color: ${defaultThemeColors.placeholder};
    font-size: ${fonts.sizes.small};
    font-weight: 500;
    white-space: nowrap;
    text-transform: capitalize;
`;

const InfoValue = styled.span`
    color: ${defaultThemeColors.txt};
    font-size: ${fonts.sizes.small};
    font-weight: 500;
    white-space: nowrap;
    text-transform: capitalize;

    & .price {
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-width: 1024px) {
            justify-content: left;
        }
        gap: 0.3rem;
    }
`;


const DesktopOnly = styled.span`
    display: none;
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    text-transform: capitalize;

    @media (min-width: 768px) {
        display: inline;
    }
`;

const MobileOnly = styled.span`
    display: inline;
    color: ${themeColor("txt")};
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    text-transform: capitalize;

    @media (min-width: 768px) {
        display: none;
    }
`;